export default __webpack_public_path__ + "static/media/cloud.5a7b3b37.png";